import { render, staticRenderFns } from "./Attestations.vue?vue&type=template&id=ab19c410&scoped=true&"
import script from "./Attestations.vue?vue&type=script&lang=js&"
export * from "./Attestations.vue?vue&type=script&lang=js&"
import style0 from "./Attestations.vue?vue&type=style&index=0&id=ab19c410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19c410",
  null
  
)

export default component.exports